export const REQUEST_MASTER_REPORT = "REQUEST_MASTER_REPORT";
export const SET_MASTER_REPORT = "SET_MASTER_REPORT";
export const ERROR_GET_MASTER_REPORT = "ERROR_GET_MASTER_REPORT";


export const SET_MESSAGE_MASTER_REPORT = "SET_MESSAGE_MASTER_REPORT";